import { FC } from 'react';

import { IconProps } from './types';

export const DocumentPlusIcon: FC<IconProps> = ({
	size,
	width = 24,
	height = 24,
	color = '#0A2653',
}) => (
	<svg
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12 19C11.448 19 11 18.553 11 18V16H9C8.448 16 8 15.553 8 15C8 14.447 8.448 14 9 14H11V12C11 11.448 11.448 11 12 11C12.552 11 13 11.448 13 12V14H15C15.553 14 16 14.447 16 15C16 15.553 15.553 16 15 16H13V18C13 18.553 12.552 19 12 19Z"
			fill={color}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18 23C19.654 23 21 21.654 21 20V7.5C21 7.235 20.895 6.98 20.707 6.793L15.207 1.293C15.02 1.105 14.766 1 14.5 1H6C4.346 1 3 2.346 3 4V20C3 21.654 4.346 23 6 23H18ZM13 3H6C5.449 3 5 3.449 5 4V20C5 20.552 5.449 21 6 21H18C18.552 21 19 20.552 19 20V9H14C13.447 9 13 8.552 13 8V3ZM18.086 7H15V3.914L18.086 7Z"
			fill={color}
		/>
	</svg>
);
